import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { BrowserRouter } from "react-router-dom";

import { App } from "./app";
import { convex } from "./convex";
import "./styles.css";

function ConfigurationError() {
  return (
    <main className="configuration-error">
      <p className="eyebrow">Build configuration</p>
      <h1>The operator console is not connected</h1>
      <p>Build this dashboard with a valid fixed VITE_CONVEX_URL.</p>
    </main>
  );
}

const root = createRoot(document.getElementById("root")!);

root.render(
  <StrictMode>
    {!convex ? (
      <ConfigurationError />
    ) : (
      <ConvexAuthProvider client={convex}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConvexAuthProvider>
    )}
  </StrictMode>,
);
